import { createContext, useContext } from "react";

export type AskNoticeboardContextValue = {
  /** Logged in, with the ai flag on */
  isAvailable: boolean;
  /** The matching model has loaded. The button stays hidden until then. */
  isReady: boolean;
  open: () => void;
};

/**
 * What AskNoticeboardProvider shares: whether Ask Noticeboard is available, and
 * opening it. Kept apart from the provider so a page can open the chat without
 * loading everything behind it.
 */
export const AskNoticeboardContext = createContext<AskNoticeboardContextValue>({
  isAvailable: false,
  isReady: false,
  open: () => {},
});

export const useAskNoticeboard = () => useContext(AskNoticeboardContext);
